import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PalantirAccordionComponent } from '../../../../accordion/accordion.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import { PalantirInputComponent } from '../../../../input/input.component';
import { PalantirTextComponent } from '../../../../text/text.component';
import type { PalantirFilterModalInstance } from '../../../filter-modal.instance';
import type {
  PalantirFilterNumberInput,
  PalantirFilterTextInput,
} from '../../../filter-modal.type';
import { PalantirFilterModalErrorDisplayComponent } from '../../shared/error-display/error-display.component';
import { filterModalInputLogger } from '../logger.instance';

const logger = filterModalInputLogger.extend('text');

@Component({
  selector: 'palantir-filter-modal-text-input-component',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: true,
  imports: [
    PalantirAccordionComponent,
    PalantirInputComponent,
    ReactiveFormsModule,
    PalantirFilterModalErrorDisplayComponent,
    PalantirIconComponent,
    PalantirTextComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirFilterModalTextInputComponent {
  public readonly definition = input.required<
    PalantirFilterNumberInput | PalantirFilterTextInput
  >();

  public readonly control = input.required<FormControl>();

  public readonly inputType = input<'number' | 'text'>('text');

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  public readonly modalInstance = input.required<PalantirFilterModalInstance<{}>>();

  // eslint-disable-next-line unicorn/consistent-function-scoping
  public canShowFilter = computed(() => {
    const canShow = this.modalInstance().dependsOnFilterComputed(this.definition().dependsOn);
    logger.debug(`Visibility check for "${this.definition().label}":`, canShow);
    return canShow;
  });
}
